import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import VeeValidate from 'vee-validate'
import vbclass from 'vue-body-class'
import Vue2Filters from 'vue2-filters'
import VuePageTransition from 'vue-page-transition'
import checkView from 'vue-check-view'
import VueAnalytics from 'vue-analytics'
import GlobalComponents from './globalComponents'

import TrackerPlugin from '@/tracker'

import { store } from './store'
import './filters'

// Library imports
import './assets/sass/main.scss'

// Modular components
Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.use(VueMoment, {
  moment
})
Vue.use(VeeValidate, {
  events: 'input' // https://github.com/baianat/vee-validate/issues/784#issuecomment-326441017
})
Vue.use(vbclass, router)
Vue.use(Vue2Filters)
Vue.use(VuePageTransition)
Vue.use(checkView)

Vue.use(GlobalComponents)

// Tracking

// Customerly
Vue.use(TrackerPlugin, {
  enabled: process.env.TRACKING_ENABLED
})

// Google Analytics
Vue.use(VueAnalytics, {
  id: 'UA-187224155-1',
  router
})

// A secondary Vue instance to communicate between components.
var EventHolder = new Vue()
Vue.prototype.EventHolder = EventHolder

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render (h) {
    return h(App)
  }
})
